import React from "react";

import CurrencyBRLMD from "@busbud/design-system-components/dist/Icons/CurrencyBRL/MD";
import CurrencyCHFMD from "@busbud/design-system-components/dist/Icons/CurrencyCHF/MD";
import CurrencyCNYMD from "@busbud/design-system-components/dist/Icons/CurrencyCNY/MD";
import CurrencyCZKMD from "@busbud/design-system-components/dist/Icons/CurrencyCZK/MD";
import CurrencyDollarMD from "@busbud/design-system-components/dist/Icons/CurrencyDollar/MD";
import CurrencyEuroMD from "@busbud/design-system-components/dist/Icons/CurrencyEuro/MD";
import CurrencyGBPMD from "@busbud/design-system-components/dist/Icons/CurrencyGBP/MD";
import CurrencyILSMD from "@busbud/design-system-components/dist/Icons/CurrencyILS/MD";
import CurrencyINRMD from "@busbud/design-system-components/dist/Icons/CurrencyINR/MD";
import CurrencyKroneMD from "@busbud/design-system-components/dist/Icons/CurrencyKrone/MD";
import CurrencyKWRMD from "@busbud/design-system-components/dist/Icons/CurrencyKWR/MD";
import CurrencyPENMD from "@busbud/design-system-components/dist/Icons/CurrencyPEN/MD";
import CurrencyPLNMD from "@busbud/design-system-components/dist/Icons/CurrencyPLN/MD";
import CurrencyRUBMD from "@busbud/design-system-components/dist/Icons/CurrencyRUB/MD";
import CurrencyTHBMD from "@busbud/design-system-components/dist/Icons/CurrencyTHB/MD";
import CurrencyTRYMD from "@busbud/design-system-components/dist/Icons/CurrencyTRY/MD";
import CurrencyZARMD from "@busbud/design-system-components/dist/Icons/CurrencyZAR/MD";
import type { Props as CreateSvgProps } from "@busbud/design-system-components/dist/utilities/createSvgIcon";

type IconComponentType = React.FC<CreateSvgProps>;

import { useAppContext } from "@app/helpers/hooks";

export const CurrencyIconMD: IconComponentType = props => {
  const { intlProvider } = useAppContext();

  let Component = CurrencyDollarMD;

  switch (intlProvider.currency) {
    case "BRL":
      Component = CurrencyBRLMD;
      break;
    case "CHF":
      Component = CurrencyCHFMD;
      break;
    case "CNY":
    case "JPY":
      Component = CurrencyCNYMD;
      break;
    case "CZK":
      Component = CurrencyCZKMD;
      break;
    case "EUR":
      Component = CurrencyEuroMD;
      break;
    case "GBP":
      Component = CurrencyGBPMD;
      break;
    case "ILS":
      Component = CurrencyILSMD;
      break;
    case "INR":
      Component = CurrencyINRMD;
      break;
    case "DKK":
    case "NOK":
    case "SEK":
      Component = CurrencyKroneMD;
      break;
    case "KRW":
      Component = CurrencyKWRMD;
      break;
    case "PEN":
      Component = CurrencyPENMD;
      break;
    case "PLN":
      Component = CurrencyPLNMD;
      break;
    case "RUB":
      Component = CurrencyRUBMD;
      break;
    case "THB":
      Component = CurrencyTHBMD;
      break;
    case "TRY":
      Component = CurrencyTRYMD;
      break;
    case "ZAR":
      Component = CurrencyZARMD;
      break;
  }

  return <Component {...props} />;
};
